import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { LocationState} from '@moduurnv2/libs-orderingapp/src/core';
import { Store } from '@ngxs/store';

/**
 * If the requester doensn't have a location in the url, something's gone wrong.  
 * So redirect them to to the home page for the location that they were at.
 * If they don't have a location in the state, and they are accessing this place, they are lost, 
 * so just send them to the empty table placeholder.
 */
@Injectable()
export class WJEmptyRedirectionGuard implements CanActivate {
  constructor(private router: Router, private store: Store) {}
  canActivate(route: ActivatedRouteSnapshot) {
    const selectedLocation = this.store.selectSnapshot(
      LocationState.getSelectedLocation
    );
    if (selectedLocation) {
      this.router.navigate([`/locations/${selectedLocation._id}/home`]);
    }
    else {
     let b64String = (route.queryParams && route.queryParams.table) ? route.queryParams.table.replaceAll(' ','+') : undefined;
      if(!b64String){
      this.router.navigate(['emptyTable'])
      }
    }
    return false;
  }
}
